import { render, staticRenderFns } from "./LikeFill.vue?vue&type=template&id=1822d0a7&scoped=true&"
import script from "./LikeFill.vue?vue&type=script&lang=js&"
export * from "./LikeFill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1822d0a7",
  null
  
)

export default component.exports